import { concatLatestFrom } from '@ngrx/operators';
import { Action, Store } from '@ngrx/store';
import { OperatorFunction, filter, map, pipe } from 'rxjs';

import { quickBetUiStateSelector } from '../quick-bet.selectors';
import { QuickBetUiState } from '../quick-bet.state';

export function ensureQuickBetActive<T extends Action>(store: Store): OperatorFunction<T, T> {
    return pipe(
        concatLatestFrom(() => store.select(quickBetUiStateSelector)),
        filter(([_, quickBetUiState]) => quickBetUiState !== QuickBetUiState.None),
        map(([action]) => action),
    );
}
